import { FC, HTMLAttributes } from 'react';
import { Typography } from 'antd';
import styles from './index.module.less';

const { Text } = Typography;

interface TextCopyableProps extends HTMLAttributes<HTMLDivElement> {
  text?: string;
}

const TextCopyable: FC<TextCopyableProps> = ({ text, children, ...props }) => {
  const copyText = text ?? (typeof children === 'string' ? (children as string) : '');

  return (
    <div className={styles.box} {...props}>
      <Text style={{ flex: '1', color: 'inherit' }} ellipsis>
        {children}
      </Text>

      {copyText ? <Text className={styles.copy} copyable={{ text: copyText }} /> : undefined}
    </div>
  );
};

export default TextCopyable;
